import React from 'react';
import I18n from 'i18n-js';
import SearchInputGroup from '@reverbdotcom/commons/src/cms/search_input_group';

interface PageSearchBarProps {
  query: string;
  queryParam: string;
  placeholderKey: string;
  queryRoute: string;
}

function PageSearchBar({
  placeholderKey = '',
  queryParam = 'query',
  query: queryProp = '',
  queryRoute,
}: PageSearchBarProps) {

  const [query, setQuery] = React.useState(queryProp);
  return (
    <SearchInputGroup
      placeholder={placeholderKey ? I18n.t(placeholderKey) : ''}
      name={queryParam}
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      action={queryRoute}
      hiddenLabel
    />
  );
}

export default PageSearchBar;
